import type { OutlineProps } from "@op/puck-types";
import { Dc_Reading } from "@op/sf-op";
import { clx, useContent } from "@op/utils";
import { useMemo } from "react";
import { useTranslation } from "@op/utils";

const Outline = (_: OutlineProps) => {
  const {
    outline: allOutlines,
    glossaryItems,
    citations: allCitations,
  } = useContent();
  const t = useTranslation();

  const citations = [
    ...allCitations.content,
    ...Object.values(allCitations.excursions).flatMap((excursion) => excursion),
  ];

  const outline = allOutlines.content;

  const nonExcursionItems =
    outline?.filter((item) => item.level !== "excursion") || [];
  const excursionItems = outline?.filter((item) => item.level === "excursion");

  const hasGlossaryItems = useMemo(
    () => glossaryItems.length > 0,
    [glossaryItems]
  );

  const hasCitations = useMemo(() => citations.length > 0, [citations]);

  return (
    <Dc_Reading.IndexItemStack className="outline-print">
      {nonExcursionItems?.map((item, index) => (
        <a href={`#${item.slug}`} key={`${item.slug}-${index}`}>
          <Dc_Reading.IndexItem
            key={index}
            layer={
              item.level === "excursion" ? "subsection" : item.level
            }
            text={item.content}
            className={clx({
              "pl-3 pr-0": item.level === "subsection",
            })}
          />
        </a>
      ))}
      {excursionItems.map((item, index) => (
        <a href={`#${item.slug}`} key={`${item.slug}-${index}`}>
          <Dc_Reading.IndexItem
            key={index}
            layer={
              item.level === "excursion" ? "subsection" : item.level
            }
            text={item.content}
            className="pl-3 pr-0"
          />
        </a>
      ))}
      {hasGlossaryItems && (
        <a href={`#glossary`}>
          <Dc_Reading.IndexItem layer="section" text={t.glossary.glossary} />
        </a>
      )}
      {hasCitations && (
        <a href={`#citations`}>
          <Dc_Reading.IndexItem layer="section" text={t.citations.citations} />
        </a>
      )}
    </Dc_Reading.IndexItemStack>
  );
};

export default Outline;
